export default "__VITE_ASSET__AZiDy2Hp__"